export default class CompanyApi {
  constructor(client, url) {
    this.url = url
    this.client = client
  }

  index(params) {
    return this.client.get(this.url, { params }).then((response) => response.data)
  }

  show(id) {
    return this.client.get(`${this.url}/${id}`).then((response) => response.data)
  }

  store(data) {
    return this.client.post(this.url, data).then((response) => response.data)
  }
  update(id, data) {
    return this.client.put(`${this.url}/full-update/${id}`, data).then((response) => response.data)
  }
  updateSpecialities(id, data) {
    return this.client.put(`${this.url}/${id}`, data).then((response) => response.data)
  }

  getConfigurations(api_key) {
    return this.client
      .get(`api/companies/${api_key}/marketing/retention/configurations`)
      .then((response) => response.data)
  }

  postConfigurations(api_key, params) {
    return this.client
      .post(`api/companies/${api_key}/marketing/retention/configurations`, params)
      .then((response) => response.data)
  }

  patchConfigurations(api_key, params) {
    return this.client
      .patch(`api/companies/${api_key}/marketing/retention/configurations`, params)
      .then((response) => response.data)
  }
}
